import { useEffect, useState } from 'react';
import { ScreenSizes } from '../../utils/constants';

const useIsMobile = () => {
    const [width, setWidth] = useState();
    const tabletMaxWidth = ScreenSizes.MAX_TABLET_WIDTH;
    const mobileMaxWidth = ScreenSizes.MAX_MOBILE_WIDTH;
    const resizeEvent = 'resize';

    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    };

    const responsiveWidths = () => {
        let isTabletWidth = false;
        let isMobileWidth = false;

        if (width <= tabletMaxWidth && width >= mobileMaxWidth) {
            isTabletWidth = true;
        } else if (width <= mobileMaxWidth) {
            isMobileWidth = true;
        }

        return { isMobileWidth, isTabletWidth };
    };

    useEffect(() => {
        setWidth(window.innerWidth);

        window.addEventListener(resizeEvent, handleWindowSizeChange);
        return () => {
            window.removeEventListener(resizeEvent, handleWindowSizeChange);
        };
    }, []);

    return responsiveWidths();
};

export default useIsMobile;
